module.exports = __webpack_public_path__ + "img/gun-turret-gun-1.3f608fb8.png";